import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

import { Button, Checkbox, Form, Input, notification, Col, Row } from "antd";

import BticinoData from "../../components/deviceRoom/bticino";
import AddDevice from "../../components/deviceRoomP/addDevice";

export default function DeviceRoom(props) {
  const [api, contextHolder] = notification.useNotification();

  const showMessage = (status, data) => {
    if (status) {
      api["success"]({
        message: "success",
        description: data.description,
      });
    } else {
      api["error"]({
        message: "error",
        description: data.description,
      });
    }
  };

  useEffect(() => {}, []);
  return (
    <div>
      {contextHolder}
      <div>
        <Row>
          <Col span={12}>
            <BticinoData showMessage={showMessage} />
          </Col>
          <Col span={12}></Col>
        </Row>
        <Row>
          <Col span={24}><AddDevice /></Col>
        </Row>
      </div>
    </div>
  );
}
